import React, { useContext } from 'react'
import { useField } from 'formik'
import FieldFrame from '../shared/forms/FieldFrame'
import { FormReadOnlyContext } from '../shared/forms/FormReadOnlyContext'
import { useFieldError } from '../shared/forms/useFieldError'

type FieldValue = string | number | null | undefined

const inputValue = (value: FieldValue): string =>
  value === null || value === undefined ? '' : String(value)

const controlClass = (inverted: boolean, error?: string) =>
  `form-control ${inverted ? 'inverted' : ''} ${error ? 'is-invalid' : ''}`

interface InputFieldProps {
  name: string
  step?: string
  placeholder?: string
  label?: string
  ariaLabel?: string
  unit?: string
  disabled?: boolean
  inverted?: boolean
}

export const InputField = ({
  name,
  step = '1',
  placeholder,
  label,
  ariaLabel,
  unit,
  disabled = false,
  inverted = true
}: InputFieldProps) => {
  const [field] = useField<FieldValue>(name)
  const { error, clearServerError, describedBy, invalid } = useFieldError(name)
  const readOnly = useContext(FormReadOnlyContext)
  const input = (
    <input
      {...field}
      id={name}
      type="number"
      step={step}
      disabled={disabled || readOnly}
      placeholder={placeholder}
      autoComplete="off"
      aria-label={ariaLabel}
      aria-invalid={invalid}
      aria-describedby={describedBy}
      value={inputValue(field.value)}
      onChange={(event) => {
        clearServerError()
        field.onChange(event)
      }}
      className={controlClass(inverted, error)}
    />
  )

  return (
    <FieldFrame name={name} label={label} error={error}>
      {unit ? (
        <div className="field-with-unit">
          {input}
          <span className="field-with-unit__unit">{unit}</span>
        </div>
      ) : (
        input
      )}
    </FieldFrame>
  )
}
